import { Injectable } from '@angular/core';
import { HelpersServicesService } from './helpers-services.service';
import { map } from 'rxjs/operators';
import { Company } from '../models/company.model';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  companyId: number;

  constructor(
    private helpers: HelpersServicesService
  ) {}

  getAllCompanies() {
    return this.helpers.getQuery( 'companies?per_page=all' )
                       .pipe(
                         map( (resp: any) => resp.data)
                       );
  }

  getCompanies( page: number = 1 ) {
    return this.helpers.getQuery( `companies?page=${ page }` )
                       .pipe(
                         map( (resp: any) => resp.data)
                       );
  }

  getCompaniesReseller( page: number = 1 ) {
    return this.helpers.getQuery( `companies/reseller?page=${ page }` )
                       .pipe(
                         map( (resp: any) => resp.data)
                       );
  }

  getCompaniesClient( page: number = 1 ) {
    return this.helpers.getQuery( `companies/client?page=${ page }` )
                       .pipe(
                         map( (resp: any) => resp.data)
                       );
  }

  getCompaniesProvider( page: number = 1 ) {
    return this.helpers.getQuery( `companies/provider?page=${ page }` )
                       .pipe(
                         map( (resp: any) => resp.data)
                       );
  }

  getAllCompaniesProvider() {
    return this.helpers.getQuery( 'companies/provider?per_page=all' )
                       .pipe(
                         map( (resp: any) => resp.data )
                       );
  }

  addCompany( company: Company ) {
    return this.helpers.postQuery( 'companies', company );
  }

  deleteImage(img) {
    return this.helpers.postQuery('companies/delete/image', {img});
  }

  deleteImageCompany(companyId: number) {
    return this.helpers.deleteQuery( `companies/${ companyId }/delete/image` );
  }

  updateCompany( company: Company, companyId: number ) {
    return this.helpers.putQuery( `companies/${ companyId }`, company );
  }

  setMultiplierProvider( companyId: number, multiplier ) {
    return this.helpers.postQuery( `companies/${ companyId }/multiplier/provider`, {multiplier} );
  }

  setMultiplierReseller( companyId: number, multiplier ) {
    return this.helpers.postQuery( `companies/${ companyId }/multiplier/reseller`, {multiplier} );
  }

  getMultiplierProvider( companyId: number ) {
    return this.helpers.getQuery( `companies/${ companyId }/multiplier/provider` )
                        .pipe(
                          map( (resp: any) => resp.data[0] )
                        );
  }

  getMultiplierReseller( companyId: number ) {
    return this.helpers.getQuery( `companies/${ companyId }/multiplier/reseller` )
                      .pipe(
                        map( (resp: any) => resp.data[0] )
                      );
  }

  getMultiplierProvidersCampaign( campaignId: number ) {
    return this.helpers.getQuery( `companies/campaigns/${ campaignId }/provider/multiplier` )
                      .pipe(
                        map( (resp: any) => resp.data )
                      );
  }

  getCompany( companyId: number ) {
    return this.helpers.getQuery( `companies/${ companyId }` )
                        .pipe(
                          map( (resp: any) => resp.data )
                        );
  }

  searchCompanies(word: string, page: number = 1) {
    return this.helpers.postQuery( `companies/search?page=${ page }`, {word} )
                        .pipe(
                          map( (resp: any) => resp.data )
                        );
  }

  getCountriesPercentage( companyId: number ) {
    return this.helpers.getQuery(`companies/${ companyId }/countries/percentage`)
                        .pipe(
                          map( (resp: any) => resp.data )
                        );
  }

  activeDisableSharedLink(companyId: number) {
    return this.helpers.getQuery(`companies/${companyId}/link-active-disable`)
                      .pipe(
                        map((resp: any) => resp.data)
                      );
  }

  getPublicScreensCompany(company: string) {
    return this.helpers.getQuery(`public/company/${company}/screens`)
                      .pipe(
                        map((resp: any) => resp.data)
                      );
  }

  getExcelScreens(companyUUID: string) {
    return this.helpers.getQuery(`companies/${ companyUUID }/screens`);
  }

  deleteImageFront(companyId: number) {
    return this.helpers.deleteQuery( `companies/${ companyId }/delete/image-front` );
  }

  deleteImageBack(companyId: number) {
    return this.helpers.deleteQuery( `companies/${ companyId }/delete/image-back` );
  }

  deleteImageBackground(companyId: number) {
    return this.helpers.deleteQuery( `companies/${ companyId }/delete/image-background` );
  }

  deleteImageLogo(companyId: number) {
    return this.helpers.deleteQuery( `companies/${ companyId }/delete/image-logo` );
  }

  deleteImageDocs(companyId: number) {
    return this.helpers.deleteQuery( `companies/${ companyId }/delete/image-logo-docs` );
  }

  deleteImagePortada(img: string) {
    return this.helpers.postQuery('companies/delete/image-portada', {img});
  }

  getProviderCampaignsDetails(companyId: number, page = 1, date) {
    return this.helpers.postQuery(`companies/provider/${ companyId }/campaigns/details?page=${ page }`, { date })
              .pipe(
                map((resp: any) => resp.data)
              );
  }

  getProviderPlanningsDetails(companyId: number, page = 1, date) {
    return this.helpers.postQuery(`companies/provider/${ companyId }/plannings/details?page=${ page }`, { date })
              .pipe(
                map((resp: any) => resp.data)
              );
  }

  loadLogo( subdomain ) {
    return this.helpers.getQuery(`public/company/logo/${ subdomain }`)
              .pipe(
                map((resp: any) => resp.data)
              );
  }

}
